import { useSyncExternalStore } from 'react'

export const useMediaQuery = (query: string): boolean => {
    const getSnapshot = () => {
        return window.matchMedia(query).matches
    }

    const subscribe = (onStoreChange: () => void) => {
        const mediaQuery = window.matchMedia(query)
        mediaQuery.addEventListener('change', onStoreChange)
        return () => mediaQuery.removeEventListener('change', onStoreChange)
    }

    return useSyncExternalStore(subscribe, getSnapshot)
}
